
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Als Faustregel gilt: `}<M mdxType="M">{`Unsere Matratze sollte alle acht bis zehn Jahre erneuert werden.`}</M>{` Wird sie länger benutzt, so sind keine idealen Hygienebedingungen mehr gewährleistet – trotz richtiger Pflege. Zudem verlieren Matratzen mit der Zeit ihre Elastizität und Stützkraft, wodurch der Körper nicht mehr optimal entlastet wird.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;